










































import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import { SimpleImage } from '~/components/common/SimpleImage';
import { PAGE_SUFFIX } from '~/constants';
import { htmlDecode } from '~/helpers/htmlDecoder';
import { ProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'CategoryTile',
  components: {
    SimpleImage,
  },
  props: {
    item: {
      type: Object as PropType<ProductInterface>,
      required: true,
    },
    noLazyLoad: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const name = computed(() => {
      const nameParts = (props.item.url_key ?? '').replace(PAGE_SUFFIX, '').replace(/-/g, ' ').split('/');
      const productNamePart = nameParts.slice(Math.max(nameParts.length - 2, 1));
      const brand = productNamePart.shift();
      const productName = props.item.name ? `${brand} ${props.item.name}` : productNamePart.join(' ');

      return htmlDecode(productName);
    });
    const categoryLink = computed(() => (props.item.url_key.includes(PAGE_SUFFIX) ? props.item.url_key : `${props.item.url_key}${PAGE_SUFFIX}`));

    return {
      name,
      categoryLink,
    };
  },
});
